import styled from 'styled-components';

const Container = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;

  textarea {
    width: 250px;
  }
`;

const DetailsContainer = styled.div`
  padding: 30px 0px 20px;
  border-bottom: 1px solid #d8e8ef;
`;

const DetailsTitle = styled.div`
  padding-bottom: 20px;
  text-align: center;
`;

const InputSection = styled.div`
  display: flex;
  margin: 17px 0px;
`;

const LeftSection = styled.div`
  width: 150px;
  font-weight: bold;
  display: flex;
  align-items: flex-start;
  vertical-align: top;
  padding-top: 8px;
  line-height: 11px;
`;

const RightSection = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
`;

const InputContainer = styled.div`
  margin: 0 auto;
  max-width: fit-content;
`;

const InputText = styled.input`
  width: 250px;
`;

export {
  Container,
  DetailsContainer,
  DetailsTitle,
  InputContainer,
  InputSection,
  LeftSection,
  RightSection,
  InputText,
};
